<p-dropdown
  #movieSelector
  [options]="allMovies"
  optionLabel="title" optionValue="movieId"
  [showClear]="true"
  appendTo="body" placeholder="Seleziona un film"
  filterPlaceholder="Digita almeno 3 caratteri"
  [disabled]="false" [filter]="true"
  (onFilter)="filterMovie($event)"
  [(ngModel)]="selectedMovieId"
  emptyMessage="Digita almeno 3 caratteri per cercare un film."
  [resetFilterOnHide]="true"
>
  <ng-template pTemplate="emptyfilter">
    <div class="p-dropdown-empty-message">
      @if (query.length >= 3) {
        Nessun film trovato per "{{ query }}".
      } @else {
        Digita almeno 3 caratteri per cercare un film.
      }
    </div>
  </ng-template>
</p-dropdown>
